import React, { createContext, useState, useContext, useEffect } from 'react';
import { api } from '../services/api';

const BusinessContext = createContext();

export function BusinessProvider({ children }) {
  const [currentBusiness, setCurrentBusiness] = useState(() => {
    // Initialize from localStorage
    const stored = localStorage.getItem('currentBusiness');
    return stored ? JSON.parse(stored) : null;
  });

  // Persist to localStorage whenever business changes
  const updateBusiness = (business) => {
    setCurrentBusiness(business);
    if (business) {
      localStorage.setItem('currentBusiness', JSON.stringify(business));
    } else {
      localStorage.removeItem('currentBusiness');
    }
  };

  return (
    <BusinessContext.Provider value={{ 
      currentBusiness, 
      setCurrentBusiness: updateBusiness 
    }}>
      {children}
    </BusinessContext.Provider>
  );
}

export function useBusiness() {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error('useBusiness must be used within a BusinessProvider');
  }
  return context;
}